







import Vue from 'vue';
import Component from 'vue-class-component';
import { Breadcrumbs, PageTitle } from '@questelservices/common-vue';
import AllClientsSummary from '@/components/auditor/all-clients-summary.vue';

@Component({
  components: {
    Breadcrumbs,
    PageTitle,
    AllClientsSummary
  }
})
export default class ClientSummary extends Vue {}
